import { useI18n } from '@/hooks/useI18n';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ApiError } from '@/api';
import { cn } from '@/lib/cn';

interface ErrorInlineProps {
  error: unknown;
  onRetry?: () => void;
  className?: string;
}

export function ErrorInline({ error, onRetry, className }: ErrorInlineProps) {
  const { t } = useI18n();
  const apiErr = ApiError.from(error);
  return (
    <div
      className={cn(
        'flex items-start gap-3 rounded-[14px] border border-rose/30 bg-rose/5 p-4',
        className,
      )}
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-rose" />
      <div className="flex-1 space-y-0.5">
        <div className="font-tech text-[10px] uppercase tracking-[0.22em] text-rose">
          {t('erreur', 'error')} · {apiErr.status || t('réseau', 'network')}
        </div>
        <p className="text-[13px] text-text-1">{apiErr.localizedMessage}</p>
      </div>
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          {t('Réessayer', 'Retry')}
        </Button>
      )}
    </div>
  );
}
